/*
This is an imitation of a magma button.
Since there was no easy way to use magma
button in the material-table we decided
to imitate it and pass as the content of the
default button in material-table
 */
import React from 'react';
import PropTypes from 'prop-types';

import { AddIcon } from 'react-magma-icons';

const AddButton = ({ isEditableAddRow, setIsEditableAddRow }) => {
  const handleClick = () => {
    const table = document.getElementById('previewTable');
    const tablePartWithScroll = table.firstChild.firstChild.nextSibling.firstChild.firstChild;

    if (!isEditableAddRow && tablePartWithScroll.scrollTop !== 0) {
      tablePartWithScroll.scrollTop = 0;
    }

    setIsEditableAddRow(prev => !prev);
  };

  return (
    <div
      className="AddButton" data-testid="addNewRow" onClick={handleClick}
    >
      <AddIcon />
      <span>Add Row</span>
    </div>
  );
};

AddButton.propTypes = {
  isEditableAddRow: PropTypes.bool.isRequired,
  setIsEditableAddRow: PropTypes.func.isRequired
};

export default AddButton;
